// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__P5T5X","ellipsis":"styles_ellipsis__BExWr","text2AndMoreLines":"styles_text2AndMoreLines__22LvW","tooltipTrigger":"styles_tooltipTrigger__2_oR9"};